export default __webpack_public_path__ + "static/showcase-e57f6d3bdca20156c6576afdd0b2212e.gif";